<app-dialog [dialogWithInput]="dialog">
    <app-view-by-id-default *ngIf="dialog.input.id"
        [id]="dialog.input.id"
        [findByIdService]="findOneService"
        (entityLoaded)="entityLoaded($event)">
            <ng-container *ngIf="formGroup.get('id').value">

                <div class="row">
                    <div class="col-12">
                        <app-card-v2 title="Informations générales">
                            <div class="row">
                                <app-form-field [required]="true" label="Date">
                                    <app-date-picker [parentFormGroup]="formGroup"
                                                     parentFormControlName="date"></app-date-picker>
                                </app-form-field>
                                <app-form-field [required]="true" label="Praticien ayant réalisé l'acte">
                                    <app-user-select-filter [parentFormGroup]="formGroup"
                                                            parentFormControlName="responsibleUserId"></app-user-select-filter>
                                </app-form-field>
                            </div>
                        </app-card-v2>
                    </div>
                    <div class="col-12">
                        <app-sale-products-card
                                title="Actes"
                                [saleId]="formGroup.get('saleId').value"
                                (saleLoadedEvent)="saleUpdated($event)">
                        </app-sale-products-card>
                    </div>
                    <div class="col-12">
                        <app-card-v2 title="Modalités de paiement">
                            <div class="row">
                                <app-form-field [required]="true" label="Acompte demandé">
                                    <app-amount-input [parentFormGroup]="formGroup"
                                                      parentFormControlName="advance"></app-amount-input>
                                </app-form-field>
                            </div>
                            <ion-grid>
                                <app-sale-save-payment-requests-form
                                        [partner]="chargedAct?.sale?.partner"
                                        [directionValue]="SALE_DIRECTION_OUT"
                                        [enableNoPaymentRequest]="false"
                                        [parentFormGroup]="formGroup"
                                        [saleDate]="formGroup.get('date').value"
                                        [saleTotalPriceVatIncluded]="formGroup.get('amount').value"
                                        [totalDepositAccordingToProducts]="formGroup.get('advance').value"
                                        parentFormControlName="payment">
                                </app-sale-save-payment-requests-form>
                            </ion-grid>
                        </app-card-v2>
                    </div>
                    <div class="col-12">
                        <app-card-v2 title="Commentaire">
                            <app-rich-text-editor [parentFormGroup]="formGroup"
                                                  parentFormControlName="comment"></app-rich-text-editor>
                        </app-card-v2>
                    </div>
                </div>
            </ng-container>
    </app-view-by-id-default>

    <app-action-button dialog-actions
                       [disabled]="!formGroup.valid"
                       [confirmationOptions]="undefined"
                       [service]="chargedActSetCompletedService"
                       [buildPayload]="buildPayload"
                       (actionSuccessEvent)="actionDone($event)"
                       (actionErrorEvent)="actionError($event)"
                       color="primary" fill="solid" label="Valider"></app-action-button>
</app-dialog>
